import { HCVisit } from '../../models/Entities/Protocols/HCVisit';
import { ErrorType } from '../../models/HttpError';

export interface VisitConceptsState {
    // Loading all concepts for a visit
    isLoading: boolean;
    isLoadingSuccess: boolean | undefined;
    failLoading: boolean;

    // Saving (if needed in the future)
    isSaving?: boolean;
    isSavingSuccess?: boolean | undefined;
    failSaving?: boolean;

    // Data
    data: HCVisit | null;
    error: ErrorType | null;
    protocolId?: number;
    visitId?: number;
    patientId?: string;
}

export const VisitConceptsUnloadState: VisitConceptsState = {
    isLoading: false,
    isLoadingSuccess: undefined,
    failLoading: false,
    data: null,
    error: null,
    protocolId: undefined,
    visitId: undefined,
    patientId: undefined
};
